import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';


export const getPriorities = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}//priority/`);
        return await response.data;
    } catch (error) {
        console.log("getPIPunchByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}